import { Api } from "@/networking";
import { UserInfoType } from "@/types";

export const getProfileAPI = () => {
  return Api.GET_PROFILE<UserInfoType>("");
};
